<div class="app-container" [class.sidebar-expanded]="sidebarVisible" [class.no-sidebar]="!showSidebar">
  <!-- Custom Sidebar -->
  <aside class="custom-sidebar" [class.expanded]="sidebarVisible" *ngIf="showSidebar">
    <!-- Sidebar Header -->
    <div class="sidebar-header">
      <div class="header-content" *ngIf="sidebarVisible">
        <img src="trenios-logo.png" alt="Trenios Logo" class="sidebar-logo" />
      </div>
      <button class="toggle-btn" (click)="toggleSidebar()">
        <i class="pi pi-times" *ngIf="sidebarVisible"></i>
        <img src="trenios-logo-icon.png" alt="Menu" class="toggle-logo-icon" *ngIf="!sidebarVisible" />
      </button>
    </div>

    <!-- Sidebar Menu -->
    <div class="sidebar-menu">
      <ul class="menu-list">
        @for (item of menuItems; track item.labelKey) {
          <li class="menu-item">
            <!-- Parent menu item with children -->
            @if (item.children && item.children.length > 0) {
              <div class="menu-group">
                <div
                  (click)="toggleMenuGroup(item.labelKey, $event)"
                  class="menu-link menu-group-link"
                  [title]="item.labelKey | translate">
                  <i [class]="item.icon"></i>
                  <span class="menu-label" *ngIf="sidebarVisible">{{ item.labelKey | translate }}</span>
                  <i
                    *ngIf="sidebarVisible"
                    class="chevron pi"
                    [class.pi-chevron-down]="!isMenuGroupExpanded(item.labelKey)"
                    [class.pi-chevron-up]="isMenuGroupExpanded(item.labelKey)"></i>
                </div>
                <!-- Inline submenu when sidebar is expanded -->
                @if (sidebarVisible && isMenuGroupExpanded(item.labelKey)) {
                  <ul class="submenu-list">
                    @for (child of item.children; track child.labelKey) {
                      <li class="submenu-item">
                        <a [routerLink]="child.route" routerLinkActive="active" class="menu-link submenu-link" [title]="child.labelKey | translate">
                          <i [class]="child.icon"></i>
                          <span class="menu-label" *ngIf="sidebarVisible">{{ child.labelKey | translate }}</span>
                        </a>
                      </li>
                    }
                  </ul>
                }
                <!-- Flyout popover when sidebar is collapsed -->
                @if (!sidebarVisible && activePopoverGroup === item.labelKey) {
                  <div class="flyout-popover" [style.top.px]="popoverTop" (click)="$event.stopPropagation()">
                    <div class="flyout-header">{{ item.labelKey | translate }}</div>
                    <ul class="flyout-list">
                      @for (child of item.children; track child.labelKey) {
                        <li class="flyout-item">
                          <a [routerLink]="child.route" routerLinkActive="active" class="flyout-link" (click)="closeFlyout()">
                            {{ child.labelKey | translate }}
                          </a>
                        </li>
                      }
                    </ul>
                  </div>
                }
              </div>
            } @else {
              <!-- Regular menu item without children -->
              <a [routerLink]="item.route" routerLinkActive="active" class="menu-link" [title]="item.labelKey | translate">
                <i [class]="item.icon"></i>
                <span class="menu-label" *ngIf="sidebarVisible">{{ item.labelKey | translate }}</span>
              </a>
            }
          </li>
        }
      </ul>
    </div>

    <!-- Sidebar Footer -->
    <div class="sidebar-footer">
      <div class="user-info">
        <i class="pi pi-user"></i>
        <span *ngIf="sidebarVisible">{{ currentUserName || ('USER.ADMIN' | translate) }}</span>
      </div>
      <button *ngIf="sidebarVisible" class="logout-icon-btn" (click)="logout()" [title]="'USER.LOGOUT' | translate">
        <i class="pi pi-sign-out"></i>
      </button>
    </div>
  </aside>

  <!-- Top Language Selector -->
  <div class="top-language-selector" *ngIf="showSidebar">
    <button class="flag-btn" (click)="toggleLanguageDropdown()">
      <span class="fi fis fi-{{ getCurrentLanguage()?.flagCode }}"></span>
    </button>
    <div class="language-dropdown" *ngIf="languageDropdownVisible">
      @for (lang of languages; track lang.code) {
        <button
          class="language-option"
          [class.active]="currentLanguage === lang.code"
          (click)="changeLanguage(lang.code)">
          <span class="fi fis fi-{{ lang.flagCode }}"></span>
          <span class="lang-name">{{ lang.name }}</span>
        </button>
      }
    </div>
  </div>

  <!-- Main Content -->
  <main class="app-content">
    <router-outlet />
  </main>
</div>
